import { useState, useEffect } from "react";
import { API_BASE } from "../config/api";

const TYPE_COLORS = {
  job:          { bg: "#eff6ff", color: "#3b82f6", label: "Job" },
  internship:   { bg: "#f5f3ff", color: "#8b5cf6", label: "Internship" },
  scholarship:  { bg: "#f0fdf4", color: "#22c55e", label: "Scholarship" },
  event:        { bg: "#fffbeb", color: "#f59e0b", label: "Event" },
  announcement: { bg: "#eff6ff", color: "#1E63C6", label: "Announcement" },
  other:        { bg: "#f9fafb", color: "#6b7280", label: "Other" },
};

export default function OpportunitiesPage() {
  const [items, setItems]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter]   = useState("all");
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/opportunities`)
      .then(r => r.json())
      .then(data => setItems(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, []);

  const types = ["all", ...new Set(items.map(i => i.type))];

  const filtered = filter === "all" ? items : items.filter(i => i.type === filter);

  const isExpired = (deadline) => {
    if (!deadline) return false;
    return new Date(deadline) < new Date();
  };

  return (
    <div className="page">
      <header className="page__hero">
        <h1>Opportunities</h1>
        <p>Jobs, internships, scholarships and announcements from Mokorotlo College.</p>
      </header>

      <section className="section">
        <div className="section__inner">

          {/* Filter tabs */}
          <div className="opp-filters">
            {types.map(t => (
              <button
                key={t}
                className={`opp-filter-btn ${filter === t ? "opp-filter-btn--active" : ""}`}
                onClick={() => setFilter(t)}
              >
                {t === "all" ? "All" : TYPE_COLORS[t]?.label || t}
              </button>
            ))}
          </div>

          {loading ? (
            <p style={{ textAlign: "center", color: "var(--text-muted)", padding: "60px 0" }}>Loading…</p>
          ) : filtered.length === 0 ? (
            <div className="opp-empty">
              <p>No opportunities available at the moment.</p>
              <p style={{ fontSize: "0.88rem", marginTop: 8 }}>Check back soon or contact us directly.</p>
            </div>
          ) : (
            <div className="opp-cards">
              {filtered.map(item => {
                const style = TYPE_COLORS[item.type] || TYPE_COLORS.other;
                const expired = isExpired(item.deadline);
                const open = expanded === item.id;

                return (
                  <div key={item.id} className={`opp-card ${expired ? "opp-card--expired" : ""}`}>
                    <div className="opp-card__header">
                      <div className="opp-card__meta">
                        <span className="opp-card__type" style={{ background: style.bg, color: style.color }}>
                          {style.label}
                        </span>
                        {expired && <span className="opp-card__expired">Closed</span>}
                        {item.deadline && !expired && (
                          <span className="opp-card__deadline">
                            Deadline: {new Date(item.deadline).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })}
                          </span>
                        )}
                      </div>
                      <h3 className="opp-card__title">{item.title}</h3>
                    </div>

                    <div className={`opp-card__body ${open ? "opp-card__body--open" : ""}`}>
                      <p className="opp-card__desc">{item.description}</p>
                    </div>

                    <button
                      className="opp-card__toggle"
                      onClick={() => setExpanded(open ? null : item.id)}
                    >
                      {open ? "Show less ▲" : "Read more ▼"}
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
